import { render, staticRenderFns } from "./DrawerOrganizationSettingsSection.vue?vue&type=template&id=5399af80&"
import script from "./DrawerOrganizationSettingsSection.vue?vue&type=script&lang=js&"
export * from "./DrawerOrganizationSettingsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports